export default [ {
    path: '/authentication/login',
    component: () => import( /* webpackChunkName: 'authentication' */ '@/views/authentication/Index' ),
    children: [ {
        path: '/authentication/login',
        component: () => import( /* webpackChunkName: 'login' */ '@/views/authentication/views/Login' ),
        name: 'login'
    }, {
        path: '/authentication/forgot',
        component: () => import( /* webpackChunkName: 'forgot' */ '@/views/authentication/views/ForgotPassword' ),
        name: 'forgot'
    }, {
        path: '/authentication/reset',
        component: () => import( /* webpackChunkName: 'reset' */ '@/views/authentication/views/ResetPassword' ),
        name: 'reset'
    } ]
}, {
    path: '/',
    component: () => import( /* webpackChunkName: 'Index' */ '@/views/Index' ),
    meta: { requiresAuth: true },
    children: [ {
        path: '/',
        component: () => import( /* webpackChunkName: 'Home' */ '@/views/Home' ),
        name: 'index',
        meta: { requiresAuth: true }
    }, {
        path: '/campaigns',
        component: () => import( /* webpackChunkName: 'Campaigns' */ '@/views/campaigns/Campaigns' ),
        name: 'campaigns',
        meta: { requiresAuth: true }
    }, {
        path: '/campaigns/add',
        component: () => import( /* webpackChunkName: 'NewCampaign' */ '@/views/campaigns/Campaign' ),
        name: 'newCampaign',
        meta: {
            requiresAuth: true,
            parent: 'campaigns',
            api: 'campaigns',
            model: 'campaign',
            isAdd: true
        }
    }, {
        path: '/campaigns/:id',
        component: () => import( /* webpackChunkName: 'Campaign' */ '@/views/campaigns/Campaign' ),
        name: 'campaign',
        meta: {
            requiresAuth: true,
            parent: 'campaigns',
            api: 'campaigns',
            model: 'campaign'
        }
    }, {
        path: '/campaigns/:campaingId/scripts/add',
        component: () => import( /* webpackChunkName: 'NewScript' */ '@/views/scripts/Script' ),
        name: 'newScript',
        meta: {
            requiresAuth: true,
            parent: 'script',
            model: 'script',
            associationAPI: true,
            isAdd: true,
            hideWidgetAddOption: true
        }
    }, {
        path: '/campaigns/:campaingId/scripts/:id',
        component: () => import( /* webpackChunkName: 'Script' */ '@/views/scripts/Script' ),
        name: 'script',
        meta: {
            requiresAuth: true,
            parent: 'script',
            associationAPI: true,
            api: 'script',
            model: 'script',
            hideWidgetAddOption: true
        }
    }, {
        path: '/campaigns/:campaingId/mail-templates/add',
        component: () => import( /* webpackChunkName: 'NewScript' */ '@/views/templates/Mail' ),
        name: 'newMailTemplate',
        meta: {
            requiresAuth: true,
            parent: 'campaigns',
            model: 'templateMail',
            associationAPI: true,
            isAdd: true,
            hideWidgetAddOption: true
        }
    }, {
        path: '/campaigns/:campaingId/mail-templates/:id',
        component: () => import( /* webpackChunkName: 'Script' */ '@/views/templates/Mail' ),
        name: 'mailTemplate',
        meta: {
            requiresAuth: true,
            parent: 'campaigns',
            associationAPI: true,
            api: 'campaigns',
            model: 'templateMail',
            hideWidgetAddOption: true
        }
    }, {
        path: '/reporting',
        component: () => import( /* webpackChunkName: 'Reporting' */ '@/views/reporting/Reporting' ),
        name: 'reporting',
        meta: { requiresAuth: true }
    }, {
        path: '/users',
        component: () => import( /* webpackChunkName: 'Users' */ '@/views/users/Users' ),
        name: 'users',
        meta: { requiresAuth: true }
    }, {
        path: '/users/add',
        component: () => import( /* webpackChunkName: 'NewUser' */ '@/views/users/User' ),
        name: 'newUser',
        meta: {
            requiresAuth: true,
            parent: 'users',
            api: 'users',
            model: 'user',
            isAdd: true
        }
    }, {
        path: '/users/:id',
        component: () => import( /* webpackChunkName: 'User' */ '@/views/users/User' ),
        name: 'user',
        meta: {
            requiresAuth: true,
            parent: 'users',
            api: 'users',
            model: 'user'
        }
    }, {
        path: '/profile/:id',
        component: () => import( /* webpackChunkName: 'User' */ '@/views/users/User' ),
        name: 'profile',
        meta: {
            requiresAuth: true,
            specificEndpoint: 'users',
            api: 'users',
            model: 'user'
        }
    }, {
        path: '/clients',
        component: () => import( /* webpackChunkName: 'Clients' */ '@/views/clients/Clients' ),
        name: 'clients',
        meta: { requiresAuth: true }
    }, {
        path: '/clients/add',
        component: () => import( /* webpackChunkName: 'NewClient' */ '@/views/clients/Client' ),
        name: 'newClient',
        meta: {
            requiresAuth: true,
            parent: 'clients',
            api: 'clients',
            model: 'client',
            isAdd: true
        }
    }, {
        path: '/clients/:id',
        component: () => import( /* webpackChunkName: 'Client' */ '@/views/clients/Client' ),
        name: 'client',
        meta: {
            requiresAuth: true,
            parent: 'clients',
            api: 'clients',
            model: 'client'
        }
    }, {
        path: '/audit',
        component: () => import( /* webpackChunkName: 'Audit' */ '@/views/audit/Audit' ),
        name: 'audit',
        meta: { requiresAuth: true, specificEndpoint: 'contacts', hideWidgetAddOption: true }
    }, {
        path: '/audit/add',
        component: () => import( /* webpackChunkName: 'Contact' */ '@/views/audit/Contact' ),
        name: 'newContact',
        meta: {
            requiresAuth: true,
            parent: 'audit',
            api: 'audit',
            model: 'contact',
            isAdd: true
        }
    }, {
        path: '/audit/:id',
        component: () => import( /* webpackChunkName: 'Contact' */ '@/views/audit/Contact' ),
        name: 'contact',
        meta: {
            parent: 'audit',
            api: 'audit',
            specificEndpoint: 'contacts',
            requiresAuth: true,
            model: 'contact'
        }
    }, {
        path: '*',
        name: 'notFound',
        component: () => import( /* webpackChunkName: 'NotFound' */ '@/views/errors/NotFound' ),
        meta: {
            requiresAuth: true,
            errorPage: true
        }
    } ]
} ];